module.exports = __webpack_public_path__ + "static/media/highTeachIco2.282bfc54.png";